import { render, staticRenderFns } from "./tariffModal.vue?vue&type=template&id=a5167e3c&scoped=true&"
import script from "./tariffModal.vue?vue&type=script&lang=js&"
export * from "./tariffModal.vue?vue&type=script&lang=js&"
import style0 from "./tariffModal.vue?vue&type=style&index=0&id=a5167e3c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5167e3c",
  null
  
)

export default component.exports